import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import ExhibitionList from '@/components/ExhibitionList'
import Help from '@/components/Help'
import Settings from '@/components/Settings'
import ShoppingCart from '@/components/ShoppingCart'
import SignDetails from '@/components/SignDetails'
import SignList from '@/components/SignList'
import SloganList from '@/components/SloganList'
import UserList from '@/components/UserList'
import store from '@/store'
import { canNavigateToRoute } from '@/services/permissions'

Vue.use(Router)

export const LOGIN = 'LOGIN'
export const DASHBOARD = 'DASHBOARD'
export const HELP = 'HELP'
export const SIGN_DETAILS = 'SIGN_DETAILS'
export const SIGNS = 'SIGNS'
export const EXHIBITIONS = 'EXHIBITIONS'
export const SETTINGS = 'SETTINGS'
export const SHOPPING_CART = 'SHOPPING_CART'
export const SLOGAN_LIST = 'SLOGAN_LIST'
export const USERS = 'USERS'

export const routeDefinitions = [
  {
    path: '/',
    name: LOGIN,
    component: Login
  },
  {
    path: '/dashboard',
    name: DASHBOARD,
    component: Dashboard
  },
  {
    path: '/exhibitions',
    name: EXHIBITIONS,
    component: ExhibitionList,
    meta: {
      requiredRoles: [1, 2]
    }
  },
  {
    path: '/help/',
    name: HELP,
    component: Help
  },
  {
    path: '/shopping-cart',
    name: SHOPPING_CART,
    component: ShoppingCart,
    meta: {
      requiredRoles: [1, 2, 3, 5]
    }
  },
  {
    path: '/settings',
    name: SETTINGS,
    component: Settings
  },
  {
    path: '/signs/',
    name: SIGNS,
    component: SignList
  },
  {
    path: '/signs/:id/:variantId?',
    props: true,
    name: SIGN_DETAILS,
    component: SignDetails
  },
  {
    path: '/slogans/',
    name: SLOGAN_LIST,
    component: SloganList,
    meta: {
      requiredRoles: [1, 2]
    }
  },
  {
    path: '/users/',
    name: USERS,
    component: UserList,
    meta: {
      requiredRoles: [1, 2]
    }
  }
]

export const routes = routeDefinitions.reduce(
  (routes, { name }) => ({ ...routes, [name]: name }),
  {}
)

const router = new Router({
  mode: 'history',
  routes: routeDefinitions
})

router.beforeResolve((to, from, next) => {
  if (!store.state.user.isLoggedIn && to.name !== LOGIN) {
    router.push({ name: LOGIN })
  } else if (store.state.user.isLoggedIn && to.name === LOGIN) {
    router.push({ name: DASHBOARD })
  } else {
    next(canNavigateToRoute(to.name))
  }

  if (store.state.user.data.hasToChangePassword && to.name !== SETTINGS) {
    router.push({ name: SETTINGS })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js